import { useMutation } from "react-query";
import { uploadAttachments } from "@/services/attachment";

/** Mutation hook that uploads media attachments for a patient. */
export function useUploadAttachments(patientUid) {
  return useMutation(function (files) {
    return uploadAttachments(patientUid, files);
  });
}